import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const StartBlank = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 20 }, forwardedRef) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.57698 3.95053C2.25 4.59226 2.25 5.43234 2.25 7.1125V13.5125C2.25 15.1927 2.25 16.0327 2.57698 16.6745C2.8646 17.239 3.32354 17.6979 3.88803 17.9855C4.52976 18.3125 5.36984 18.3125 7.05 18.3125H13.45C15.1302 18.3125 15.9702 18.3125 16.612 17.9855C17.1765 17.6979 17.6354 17.239 17.923 16.6745C18.25 16.0327 18.25 15.1927 18.25 13.5125V7.1125C18.25 5.43234 18.25 4.59226 17.923 3.95053C17.6354 3.38604 17.1765 2.9271 16.612 2.63948C15.9702 2.3125 15.1302 2.3125 13.45 2.3125H7.05C5.36984 2.3125 4.52976 2.3125 3.88803 2.63948C3.32354 2.9271 2.8646 3.38604 2.57698 3.95053ZM10.2501 15.0626C9.78066 15.0626 9.4001 14.682 9.4001 14.2126V11.1626H6.3501C5.88066 11.1626 5.5001 10.782 5.5001 10.3126C5.5001 9.84316 5.88066 9.4626 6.3501 9.4626H9.4001V6.4126C9.4001 5.94316 9.78066 5.5626 10.2501 5.5626C10.7195 5.5626 11.1001 5.94316 11.1001 6.4126V9.4626H14.1501C14.6195 9.4626 15.0001 9.84316 15.0001 10.3126C15.0001 10.782 14.6195 11.1626 14.1501 11.1626H11.1001V14.2126C11.1001 14.682 10.7195 15.0626 10.2501 15.0626Z"
          fill="url(#paint0_linear_3561_257)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_3561_257"
            x1="10.25"
            y1="2.3125"
            x2="10.25"
            y2="18.3125"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D9D9D9" />
            <stop offset="1" stopColor="#737373" />
          </linearGradient>
        </defs>
      </svg>
    )
  },
)

export default StartBlank
